import { useFormContext, Controller } from 'react-hook-form';
import { Box, Button, FormControl, InputAdornment, TextField } from '@mui/material';
import GlobalLineIcon from 'remixicon-react/GlobalLineIcon';
import FileUpload from './FileUpload';
import { WriteWithAITabName } from '../../hooks/useWriteWithAI';
import { WriteWithAIFormValues } from '../../hooks/useWriteWithAIForm';
import TextEditor from './TextEditor';

type WriteWithAIFormProps = {
  tab: WriteWithAITabName;
  onGenerate: () => void;
};

function WriteWithAIForm({ tab, onGenerate }: WriteWithAIFormProps) {
  const {
    control,
    formState: { isSubmitting, isDirty, isValid },
  } = useFormContext<WriteWithAIFormValues>();
  return (
    <Box sx={{ marginTop: 1 }}>
      {tab === WriteWithAITabName.TEXT && (
        <>
          <TextEditor />
          {/* <Box display="flex" alignItems="center" justifyContent="flex-end">
            <Button onClick={onGenerate} variant="contained" disabled={!isDirty || !isValid}>
              Submit
            </Button>
          </Box> */}
        </>
      )}
      {tab === WriteWithAITabName.URL && (
        <Controller
          control={control}
          name="url"
          render={({ field, fieldState }) => (
            <FormControl fullWidth>
              <TextField
                {...field}
                error={!!fieldState.error}
                helperText={fieldState?.error?.message || ''}
                fullWidth
                placeholder="Enter your URL here"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <GlobalLineIcon />
                    </InputAdornment>
                  ),
                  sx: {
                    '& .MuiInputBase-input': {
                      padding: '14px 0px',
                    },
                  },
                }}
                disabled={isSubmitting}
              />
            </FormControl>
          )}
        />
      )}
      {tab === WriteWithAITabName.URL && <FileUpload />}
    </Box>
  );
}

export default WriteWithAIForm;
